import React from "react";
import { useForm } from "react-hook-form";
import { env } from "../../constants/global.constants";
import { api } from "../../services/http.service";
import { modalServiceSubject } from "../../services/modal.service";
import paths from "../../paths";
var s;
var resendButton;
// Global state for modal flow
var currentUserData = null;
var currentCode = '';
export default function ForgetPassword(props) {
    var _a = useForm(), register = _a.register, handleSubmit = _a.handleSubmit, errors = _a.formState.errors;
    var senderTimer = function (s) {
        if (s === void 0) { s = null; }
        var resendTimer = document.getElementById("id_resendTimer");
        if (resendTimer) {
            var secondLeft = Number(Number(resendTimer.innerHTML.split(":")[0]) * 60 +
                Number(resendTimer.innerHTML.split(":")[1]) -
                1);
            if (secondLeft < 0) {
                clearInterval(s);
                resendButton = document.getElementById("id_resendCode");
                if (resendButton) {
                    resendButton.classList.remove("hide");
                }
            }
            else {
                resendTimer.innerHTML =
                    Math.floor(secondLeft / 60) +
                        ":" +
                        ("00" + (secondLeft % 60)).slice(-2);
            }
        }
    };
    var showTCKNModal = function () {
        modalServiceSubject.next({
            case: "info",
            title: "Şifremi Unuttum",
            width: "400px",
            content: "\n                <div class=\"text-left\">\n                    <p>Size ait TC Kimlik numaras\u0131n\u0131 girin. Kay\u0131tlar\u0131m\u0131zla e\u015Fle\u015Firlerse, size \u015Fifrenizi nas\u0131l s\u0131f\u0131rlayaca\u011F\u0131n\u0131z\u0131 a\u00E7\u0131klayan bir e-posta g\u00F6nderece\u011Fiz.</p>\n                    <form id=\"tcknForm\">\n                        <div class=\"mb-3\">\n                            <label for=\"tc_id\" class=\"form-label\">TC Kimlik Numaras\u0131</label>\n                            <input type=\"number\" class=\"form-control\" id=\"tc_id\" name=\"tc_id\" min=\"10000000000\" max=\"99999999999\" placeholder=\"Hesab\u0131n\u0131za kay\u0131tl\u0131 TCKN\" required>\n                        </div>\n                    </form>\n                </div>\n            ",
            confirm: {
                sure: {
                    label: "Gönder",
                    class: "btn-primary w-100",
                    action: function () {
                        var _a;
                        var form = document.getElementById('tcknForm');
                        var tcId = (_a = document.getElementById('tc_id')) === null || _a === void 0 ? void 0 : _a.value;
                        if (tcId && tcId.length === 11) {
                            onSubmit({ tc_id: tcId });
                        }
                        else {
                            modalServiceSubject.next({
                                case: "danger",
                                title: "Hata!",
                                content: "<p>L\u00FCtfen ge\u00E7erli bir TC Kimlik numaras\u0131 giriniz.</p>",
                                confirm: {
                                    cancel: {
                                        class: "btn-danger",
                                        label: "Tamam",
                                    },
                                },
                            });
                        }
                    },
                },
                cancel: {
                    label: "İptal",
                    class: "btn-secondary w-100",
                    action: function () {
                        currentUserData = null;
                        currentCode = '';
                        if (props.closePasswordModal) {
                            props.closePasswordModal();
                        }
                    },
                },
            },
        });
    };
    var showSelectionModal = function (data) {
        var content = "\n            <div class=\"text-left\">\n                <p>\u015Eifre S\u0131f\u0131rlama linkini g\u00F6nderim y\u00F6ntemini se\u00E7iniz</p>\n        ";
        if (data.mobile) {
            content += "\n                <div class=\"card mb-3 pointer\" onclick=\"window.selectMethod('sms')\">\n                    <div class=\"card-body\">\n                        <h5>Telefon ile S\u0131f\u0131rlama</h5>\n                        <p class=\"mb-0\">".concat(data.mobile, " numaral\u0131 telefonunuza s\u0131f\u0131rlama linki g\u00F6nderilecektir</p>\n                    </div>\n                </div>\n            ");
        }
        if (data.email) {
            content += "\n                <div class=\"card mb-3 pointer\" onclick=\"window.selectMethod('mail')\">\n                    <div class=\"card-body\">\n                        <h5>E-posta ile S\u0131f\u0131rlama</h5>\n                        <p class=\"mb-0\">".concat(data.email, " e-posta adresinize s\u0131f\u0131rlama linki g\u00F6nderilecektir</p>\n                    </div>\n                </div>\n            ");
        }
        content += "</div>";
        // Global function for selection
        window.selectMethod = function (type) {
            callChangePasswordApi(type);
        };
        modalServiceSubject.next({
            case: "info",
            title: "Gönderim Yöntemi Seçin",
            width: "400px",
            content: content,
            confirm: {
                cancel: {
                    class: "btn-secondary w-100",
                    label: "İptal",
                    action: function () {
                        if (props.closePasswordModal) {
                            props.closePasswordModal();
                        }
                    },
                },
            },
        });
    };
    var showCodeModal = function () {
        modalServiceSubject.next({
            case: "info",
            title: "Doğrulama Kodu",
            width: "400px",
            content: "\n                <div class=\"text-left\">\n                    <p>Size g\u00F6nderilen do\u011Frulama kodunu giriniz.</p>\n                    <form id=\"codeForm\">\n                        <div class=\"mb-3\">\n                            <label for=\"code\" class=\"form-label\">Do\u011Frulama Kodu</label>\n                            <input type=\"text\" class=\"form-control\" id=\"code\" name=\"code\" placeholder=\"___ ___\" maxlength=\"6\" required>\n                            <div class=\"form-text position-absolute\" style=\"right: 10px; top: 50px;\">\n                                <span id=\"id_resendTimer\">2:00</span>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            ",
            confirm: {
                sure: {
                    label: "Doğrula",
                    class: "btn-primary w-100",
                    action: function () {
                        var _a, _b;
                        var code = (_b = (_a = document.getElementById('code')) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.replaceAll(' ', '');
                        if (code && code.length === 6) {
                            onSubmitCode({ code: code });
                        }
                        else {
                            modalServiceSubject.next({
                                case: "danger",
                                title: "Hata!",
                                content: "<p>L\u00FCtfen ge\u00E7erli bir do\u011Frulama kodu giriniz.</p>",
                                confirm: {
                                    cancel: {
                                        class: "btn-danger",
                                        label: "Tamam",
                                    },
                                },
                            });
                        }
                    },
                },
                cancel: {
                    label: "Tekrar Gönder",
                    class: "btn-warning w-100",
                    action: function () {
                        clearInterval(s);
                        callChangePasswordApi();
                        // Timer'ı yeniden başlat
                        s = setInterval(senderTimer, 1000);
                    },
                },
            },
        });
        // Start timer
        s = setInterval(senderTimer, 1000);
    };
    var showNewPasswordModal = function () {
        modalServiceSubject.next({
            case: "info",
            title: "Yeni Şifre Belirle",
            width: "400px",
            content: "\n                <div class=\"text-left\">\n                    <p>Yeni \u015Fifrenizi belirleyiniz.</p>\n                    <form id=\"passwordForm\">\n                        <div class=\"mb-3\">\n                            <label for=\"password\" class=\"form-label\">\u015Eifre</label>\n                            <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" required>\n                        </div>\n                        <div class=\"mb-3\">\n                            <label for=\"password2\" class=\"form-label\">\u015Eifre (Tekrar)</label>\n                            <input type=\"password\" class=\"form-control\" id=\"password2\" name=\"password2\" required>\n                        </div>\n                    </form>\n                </div>\n            ",
            confirm: {
                sure: {
                    label: "Şifreyi Güncelle",
                    class: "btn-success w-100",
                    action: function () {
                        var _a, _b;
                        var password = (_a = document.getElementById('password')) === null || _a === void 0 ? void 0 : _a.value;
                        var password2 = (_b = document.getElementById('password2')) === null || _b === void 0 ? void 0 : _b.value;
                        if (password && password2 && password === password2) {
                            onSubmitPassword({ password: password, password2: password2 });
                        }
                        else {
                            modalServiceSubject.next({
                                case: "danger",
                                title: "Hata!",
                                content: "<p>\u015Eifreler e\u015Fle\u015Fmiyor. L\u00FCtfen kontrol ediniz.</p>",
                                confirm: {
                                    cancel: {
                                        class: "btn-danger",
                                        label: "Tamam",
                                    },
                                },
                            });
                        }
                    },
                },
                cancel: {
                    label: "İptal",
                    class: "btn-secondary w-100",
                    action: function () {
                        currentUserData = null;
                        currentCode = '';
                        if (props.closePasswordModal) {
                            props.closePasswordModal();
                        }
                    },
                },
            },
        });
    };
    var onSubmit = function (data) {
        api
            .start("post", env.accounting_api + "/member/api/member-contact-information/", data, false)
            .then(function (res) {
            if (res.status) {
                currentUserData = res.data;
                showSelectionModal(res.data);
            }
            else {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata!",
                    content: "<p>".concat(res.message, "</p>"),
                    confirm: {
                        cancel: {
                            class: "btn-danger",
                            label: "Kapat",
                        },
                    },
                });
            }
        })
            .catch(function (e) {
            // console.log(e)
        });
    };
    var onSubmitCode = function (data) {
        data.code = data.code.replaceAll(' ', '');
        api
            .start("post", env.accounting_api + "/member/api/password-code-validate/", data, false)
            .then(function (res) {
            if (res.status) {
                currentCode = data.code;
                clearInterval(s);
                showNewPasswordModal();
            }
            else {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata!",
                    content: "<p>".concat(res.message, "</p>"),
                    confirm: {
                        cancel: {
                            class: "btn-danger",
                            label: "Kapat",
                        },
                    },
                });
            }
        })
            .catch(function (e) {
            // console.log(e)
        });
    };
    var onSubmitPassword = function (data) {
        data.code = currentCode.replaceAll(' ', '');
        api
            .start("post", env.accounting_api + "/member/api/password-renew-with-code/", data, false)
            .then(function (res) {
            if (res.status) {
                modalServiceSubject.next({
                    case: "success",
                    title: "İşleminiz Başarılı",
                    content: "<p class=\"text-center\">".concat(res.message, "</p>"),
                    confirm: {
                        sure: {
                            label: "Tamam",
                            class: "btn-success w-100",
                            action: function () {
                                // Close all modals and reset state
                                currentUserData = null;
                                currentCode = '';
                                if (props.closePasswordModal) {
                                    props.closePasswordModal();
                                }
                            },
                        },
                    },
                });
            }
            else {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata!",
                    content: "<p>".concat(res.message, "</p>"),
                    confirm: {
                        cancel: {
                            class: "btn-danger",
                            label: "Kapat",
                        },
                    },
                });
            }
        })
            .catch(function (e) {
            // console.log(e)
        });
    };
    var callChangePasswordApi = function (type) {
        if (type === void 0) { type = null; }
        var data = {
            return_address: "".concat(window.location.protocol, "//").concat(window.location.host).concat(paths.resetPassword.url),
            messenger_type: type,
            user_id: currentUserData === null || currentUserData === void 0 ? void 0 : currentUserData.user_id,
        };
        api
            .start("post", env.accounting_api + "/member/api/password-reminder/", data, false)
            .then(function (res) {
            if (res.status) {
                showCodeModal();
            }
            else {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata!",
                    content: "<p>".concat(res.message, "</p>"),
                    confirm: {
                        cancel: {
                            class: "btn-danger",
                            label: "Kapat",
                        },
                    },
                });
            }
        })
            .catch(function (e) {
            // console.log(e)
        });
    };
    // Props'tan gelen passwordModal değişikliğini izle
    React.useEffect(function () {
        if (props.passwordModal === true) {
            // Modal açıldığında global state'i sıfırla ve TCKN modal'ını göster
            currentUserData = null;
            currentCode = '';
            clearInterval(s);
            // Kısa bir delay ile modal'ı göster
            setTimeout(function () {
                showTCKNModal();
            }, 100);
        }
    }, [props.passwordModal]);
    return null; // Artık JSX render etmiyoruz, sadece modal servisi kullanıyoruz
}
